import {
  Box,
  Button,
  DialogActions,
  TextField,
  Typography,
} from "@mui/material";
import {
  RentGuaranteeType,
  RentType,
  ZyusetuType,
} from "@/graphql/graphql";
import {ZyusetuTemplateAutocomplete} from "@/components/input/ZyusetuTemplateAutocoplete";
import toast from "react-hot-toast";

interface ZyusetuCreationFormProps {
  title: string;
  onTitleChange: (title: string) => void;
  rentType?: RentType;
  rentGuaranteeType?: RentGuaranteeType;
  zyusetuType: ZyusetuType;
  onSubmit: () => void;
  disabled?: boolean;
  onTemplateSelect: (templateId: string | null) => void;
}

export function ZyusetuCreationForm({
                                      title,
                                      onTitleChange,
                                      rentType,
                                      rentGuaranteeType,
                                      zyusetuType,
                                      onSubmit,
                                      disabled,
                                      onTemplateSelect,
                                    }: ZyusetuCreationFormProps) {
  return (
    <Box>
      <Typography color="text.secondary" variant="subtitle2" mb={0.5}>
        重説タイトル
      </Typography>
      <TextField
        fullWidth
        size={"small"}
        value={title}
        onChange={(event) => {
          if (event.target.value.includes("/")) {
            toast.error("ファイル名に/を含めることはできません");
          } else {
            onTitleChange(event.target.value);
          }
        }}
      />
      
      <Box mt={2}>
        <ZyusetuTemplateAutocomplete
          onChange={(entity) => {
            onTemplateSelect(entity?.id || null);
          }}
          rentType={rentType}
          rentGuaranteeType={rentGuaranteeType}
          zyusetuType={zyusetuType}
        />
      </Box>
      
      <Typography>
        ※全宅は現在開発中になります
      </Typography>
      <DialogActions sx={{p: 2}}>
        <Button
          variant={"contained"}
          disabled={disabled}
          onClick={onSubmit}
        >
          このテンプレートで作成
        </Button>
      </DialogActions>
    </Box>
  );
}
